export default "__VITE_ASSET__CzYcDs9C__"